export default "__VITE_ASSET__UAGkg5kn__"